var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alina-flex-vertical-container",class:{
        'alina-vh-100':!_vm.pageIsInIframe
      },style:({
        'overflow': _vm.pageIsInIframe ? 'hidden':''
      })},[(!_vm.fullScreen)?_c('div',{staticClass:"alina-flex-vertical-header"},[_c('MenuHorizontalMain')],1):_vm._e(),_c('div',{staticClass:"alina-flex-vertical-content"},[_c('Messages'),_c('Spinner'),_c('router-view')],1),(!_vm.fullScreen)?_c('div',{staticClass:"alina-flex-vertical-footer"},[_c('Footer')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }